define((require) => {
    "use strict";

    const EventDispatcher = require("shared/util/EventDispatcher");
    const {
        LIGHTBOX_OPEN, LIGHTBOX_CLOSE, LINK_VISIT,
        JAVASCRIPT_EXECUTE, PRODUCT_VIEW, SCENE_NAVIGATE,
        IMAGE_VIEW, WIDGET_VIEW, SOCIAL_NETWORK_SHARE, VIEWER_ERROR
    } = require("shared/services/tracker/ViewerEventsConstants");

    /**
     * The singleton event bus used to trigger and/or listen for events internally to the Viewer <b>and</b>
     * Channels. <p>
     *
     * The event names defined here are <b>not</b> the analytics events tracked, but they may be the cause of
     * such tracked events. Internal events are generally coarse ("reusable"), primed with data describing
     * the internal context triggering the event, such as a PRODUCT_VIEWED event describing where or how the
     * product was viewed, e.g. "quickview", "link", etc. <p>
     *
     * All events are triggered with at least two arguments, in order: <ol>
     *
     * <li> <tt>source</tt>: the source of the event, e.g. the Link Action triggering an <tt>LINK_VISIT</tt>
     *                       event; never falsey.
     *
     * <li> <tt>experienceId</tt>: the id of the Experience currently viewed (especially needed by Channels).
     *
     * <li> <tt>varArgs</tt>: additional event specific var args, such as the <tt>LINK_VISIT</tt> supplying the
     *                        visited url as the third argument, or the <tt>PRODUCT_VIEW</tt> event supplying an
     *                        object like <tt>{type: "demandware", context: "quickview", productId: some-id}</tt>.
     *
     * </ul>
     *
     * A note on event naming: all event dispatching is synchronous, triggering listeners while the event is in
     * progress so to speak. For this reason, event constants and names are written in present tense.
     *
     * @class ViewerEvents
     * @constructor
     */
    const ViewerEvents = EventDispatcher.extend("ViewerEvents", {

        LIGHTBOX_OPEN,
        LIGHTBOX_CLOSE,
        LINK_VISIT,
        JAVASCRIPT_EXECUTE,
        PRODUCT_VIEW,
        SCENE_NAVIGATE,
        SOCIAL_NETWORK_SHARE,
        IMAGE_VIEW,
        WIDGET_VIEW,

        // E.g. on Action failing to be activated
        VIEWER_ERROR

    });

    // Singleton
    return new ViewerEvents();
});



// WEBPACK FOOTER //
// ./src/shared/services/ViewerEvents.js